import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";
import type { components } from "../schema";

import { TAGS_QUERY_KEY } from "./useTags";

type UpdateTagBody = components["schemas"]["UpdateTagBody"];
type TagResponse = components["schemas"]["TagResponse"];

export type UpdateTagVariables = {
  tagId: string;
  body: UpdateTagBody;
};

export function useUpdateTag() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation<TagResponse, Error, UpdateTagVariables>({
    mutationFn: async ({ tagId, body }) => {
      const { data, error } = await client.PATCH("/api/tags/{tag_id}", {
        params: { path: { tag_id: tagId } },
        body,
      });
      if (error !== undefined) {
        throw new Error(`Failed to update tag ${tagId}`);
      }
      return data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: TAGS_QUERY_KEY });
    },
  });
}
